import { Filters } from "src/types/interfaces/filters";
import { isBooleanArray } from "../is-boolean-array";
import { isNumberArray } from "../is-number-array";

export const getSelectedFilters = (filters: Filters, groupType: string): string[] => {
  const values = filters[groupType]?.value ?? [];

  // If the values are numbers or booleans, convert them to strings
  if (isNumberArray(values) || isBooleanArray(values)) {
    return values.map(item => item.toString());
  }

  return values as string[];
};
